import { POST_TYPES } from 'lib/constants';
import { createAltTextForPosts } from 'lib/helpers';
import { Post } from 'lib/types';
import { imagePostUrl } from 'lib/utils/imageUtils';

interface Props {
  post: Post;
}
export const PostImg = ({
  post,
}: Props) => {
  const imgBgUrl = imagePostUrl(post.thumbnailUrl,
    { width: 100, height: 100, isDead: !post.isLive });
  if (imgBgUrl) {
    return (
      <img
        className="min-w-[100px] min-h-[56px]"
        alt={createAltTextForPosts(post)}
        src={imgBgUrl}
        loading="lazy"
      />
    );
  }

  const t = post.type === POST_TYPES.TEXT ? 'Text' : 'N/A';
  return <div className="max-w-[100px] min-w-[100px] h-full bg-lightgray flex justify-center items-center">{t}</div>;
};
